import React, { useMemo } from 'react'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import TableCell from '@material-ui/core/TableCell'
import { TotalTableFooter } from 'components/dashboard/totalTableFooter'

import { localized } from 'decorators'
import { DashboardItem, formatters } from 'components/dashboard'
import { api } from 'store/modules/dashboard'

import { useStyles } from './index.css'

const DataRow = ({ localize, data, classes }) => {
  return (
    <TableRow>
      <TableCell title={data.name} className={classes.name}>{data.name}</TableCell>
      <TableCell align='right' className={classes.count}>{formatters(localize).bottles(data.bottlesCount)}</TableCell>
      <TableCell align='right' className={classes.price}>{formatters(localize).prices(data.totalPrice)}</TableCell>
    </TableRow>
  )
}
export const BottlesByStatus = localized(({ localize }) => {
  const classes = useStyles()
  const [data, setData] = React.useState(null)
  const handleData = React.useCallback(x => setData(x), [setData])

  const totalCount = useMemo(() => data && data.length > 0 ? data.map(x => x.bottlesCount).reduce((total, curr) => total + curr) : 0, [data])
  const totalPrice = useMemo(() => data && data.length > 0 ? data.map(x => x.totalPrice).reduce((total, curr) => total + curr) : 0, [data])
  
  return (
    <DashboardItem
      title={localize('dashboard.bottlesByStatus_title')}
      dataSource={api.getBottlesByStatus}
      bodyClassName={classes.root}
      onDataReceived={handleData}>
      {data && <div className={classes.body}>
          <Table className={classes.table} stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>{localize('dashboard.bottlesByStatus_name')}</TableCell>
                <TableCell align='right' className={classes.count}>{localize('dashboard.bottlesByStatus_bottlesCount')}</TableCell>
                <TableCell  align='right' className={classes.price}>{localize('dashboard.bottlesByStatus_totalPrice')}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((x, idx) => <DataRow key={idx} localize={localize} data={x} classes={classes} />)}
            </TableBody>
            <TotalTableFooter totalCount={totalCount} totalPrice={totalPrice} />
          </Table>
        </div>}
    </DashboardItem>
  )
})
